import apiClient from "./api";
class StateService{
 
      async GetStates() { 
        try {
          const response = await apiClient.get("/state/list"); 
          return response.data;
          
        } catch (err) {
        }
      }

      async GetCredentialNewRequestStatus() { 
        try {
          const response = await apiClient.get("/credential/can-start-new-request"); 
          return response.data;
          
        } catch (err) {
        }
      }
}
export default new StateService();